/**
 * DramaCategoryBadge — json-render web wrapper
 *
 * Web implementation for the json-render catalog (web-only, Phase 1).
 * Visual spec: Sally (Discourse #3543/4) — Section 3
 *
 * Delegates to drama-badge.tsx style helpers (getDramaBadgeContent,
 * dramaBadgeStyles).
 *
 * Task: [#783.S4] NocoDB #787
 * Agent: Diego <diego@liftping.net>
 */
"use client";

import React from "react";
import {
  getDramaBadgeContent,
  dramaBadgeStyles,
} from "../../components/drama-badge";
import { cn } from "../../lib/utils";
import type { DramaCategoryBadgeProps } from "../schema";

const sizeClasses: Record<"sm" | "md" | "lg", string> = {
  sm: "text-xs px-2 py-1",
  md: "text-sm px-3 py-1.5",
  lg: "text-base px-4 py-2",
};

export function DramaCategoryBadge({
  category,
  size = "md",
  showIcon = true,
}: DramaCategoryBadgeProps) {
  const { label, emoji, className } = getDramaBadgeContent(category, showIcon);

  return (
    <span className={cn(dramaBadgeStyles.container, sizeClasses[size], className)}>
      {emoji && <span className={dramaBadgeStyles.emoji}>{emoji}</span>}
      <span
        className={cn(
          dramaBadgeStyles.label,
          size === "sm" ? "text-xs" : "text-sm"
        )}
      >
        {label}
      </span>
    </span>
  );
}
